<template>
  <b-form @submit.prevent="openModalConfirm">
    <div class="form-parameter-wrapper">
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Bonus Skema Angsuran" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group append="%">
              <b-form-input v-model="angsuranInput.BONUS_SKEMA_ANGSURAN" name="bonusSkemaAngsuran" type="number" step="0.01" min="0" max="100" required />
            </b-input-group>
            <span class="smallText text-muted">Persentase penyesuaian harga barang saat nasabah memilih skema angsuran.</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group v-for="tenor in tenorList" :key="tenor" label-cols-sm="12" label-cols-lg="3" :label="`Diskon Pelunasan Tenor ${tenor} Bulan`" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group append="%">
              <b-form-input v-model="angsuranInput['DISKON_PELUNASAN_INSTALLMENT_TENOR_' + tenor]" :name="`diskonPelunasanTenor${tenor}`" type="number" step="1" min="0" max="100" required />
            </b-input-group>
            <span class="smallText text-muted">Persentase diskon saat pelunasan angsuran dengan tenor {{ tenor }} bulan.</span>
          </b-col>
        </b-row>
      </b-form-group>
    </div>
    <div class="form-wrapper-btn submit-btn-wrapper">
      <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
    </div>
    <ModalConfirm
      id="modal-edit-angsuran"
      title="Confirm Edit Parameter Angsuran"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mengubah parameter angsuran ini?"
      @submit="onSubmit"
    />
  </b-form>
</template>

<script>
export default {
  name: "parameter-angsuran",
  props: {
    angsuranInput: { type: Object, required: true },
  },
  data() {
    return {
      isSubmitting: false,
      tenorList: [3, 6, 12, 18, 24, 36],
    };
  },
  methods: {
    onSubmit() {
      let payload = new FormData();
      for (let [key, value] of Object.entries(this.angsuranInput)) {
        payload.append("name", key);
        payload.append("value", value);
      }

      this.isSubmitting = true;
      this.$axios.post("parameter/update/", payload).then(() => {
        this.$helper.toastSucc(this, "Parameter Angsuran telah berhasil diubah!");
        this.$bvModal.hide("modal-edit-angsuran");
      })
        .catch(error => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    openModalConfirm() {
      this.$bvModal.show("modal-edit-angsuran");
    },
  },
};
</script>
